import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestResponse } from "../model/dto/RequestResponse";
import { PriceLabel } from "../model/PriceLabel";

@Injectable()
export class PriceLabelFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    PostPriceLabel(request: PriceLabel): Observable<RequestResponse<number>> {
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/PriceLabel', request);
    }

    GetByTypeActive(organizationId: String, catDetTypePriceId: number, catDetPrinterTypeId: number): Observable<RequestResponse<PriceLabel>> {
        return this._httpClient.get<RequestResponse<PriceLabel>>(
            this._urlBase + 'api/PriceLabel/ByTypeActive?organizationId=' + organizationId + '&catDetTypePriceId=' + catDetTypePriceId + '&catDetPrinterTypeId=' + catDetPrinterTypeId);
    }
}